import styled from 'styled-components'

export const WrapperLateral = styled.div`
  width: 100%;
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .button__eye{
    padding: 8px;
    border-radius: 6px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5da57d;
    border: 2px solid #5da57d;
  }

  .button__eye:hover {
    background-color: var(--cor-do-item);
    border: 2px solid  var(--cor-do-item);
    color: white;
  }

  .button__eye:is([data-active='true']) {
    background-color: var(--cor-do-item);
    border: 2px solid  var(--cor-do-item);
    color: white;
  }

  .fundo__lateral {
    width: 100%;
    height: calc(100vh - 167px);
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .card__analise {
      border: 2px solid #d9d9d9;
      padding: 10px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .title__analises {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .points-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .point-card {
      background-color: var(--cor-do-item);
      color: white;
      border: 2px solid var(--cor-do-item);
      font-weight: 700;
      font-size: 12px;
      width: 30px !important;
      height: 30px;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
    }
  }

  .ant-collapse-content-box {
    padding: 10px !important;
  }

  .container__adicionados {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    gap: 5px;
  }

  .header__adicionados {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nome__analise {
      padding: 7px;
      font-size: 11px;
      font-weight: 700;
      color: white;
      border-radius: 5px;
    }
  }

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }

  .point-card:hover {
    transition: 0.5s;
    transform: scale(1.05);
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }
`
